/*
 * @description 本文件所有export必须是RegExp类型
 * 所有正则的验证必须在本文件中统一
 */

// 密码
export const PASSWORD_REGEXP: RegExp = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[~!@#$%^&*\(\)_+`])[0-9A-Za-z~!@#$%^&*()_+`]{8,20}$/;

// 账号
export const ACCOUNT_REGEXP: RegExp = /^[a-zA-Z0-9_]+$/;

// 邮编
export const POST_CODE_REGEXP: RegExp = /^[0-9]{6}$/;

// 手机
export const MOBILE_REGEXP: RegExp = /^[1][3-9][0-9]{9}$/;

// 座机
export const PHONE_REGEXP: RegExp = /^([0-9]{3,4}-)?[0-9]{7,8}$/;

// 座机&手机
export const TELEPHONE_MOBILE_REGEXP: RegExp = /^((1[3-9][0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/;

// 纯数字
export const NUMBER_REGEXP: RegExp = /^[0-9]*$/;

// 纯英文&下划线&数字
export const ENGLISH_UNDERLINE_REGEXP: RegExp = /^[a-zA-Z_0-9]+$/;

// 不超过100的数字
export const LESS_THAN_REGEXP: RegExp = /^(?:[1-9]?\d|100)$/;

// 大于0的数字
export const GREATER_THAN_REGEXP: RegExp = /^([1-9][0-9]*)+$/;

// 四位大写字母
export const CAPITAL_REGEXP: RegExp = /^[A-Z]{4}$/;

// 身份证
export const ID_CARD_REGEXP: RegExp = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

// 社会信用代码
export const CREDIT_CODE_REGEXP: RegExp = /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g;

// 网址
export const WEB_SITE_REGEXP: RegExp = /^((https|http|ftp|rtsp|mms){0,1}(:\/\/){0,1})(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;

// ip
export const IP_ADDR_REGEXP: RegExp = /^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$/;
